import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Marker } from "@react-google-maps/api";
import TruckLocation from "../../../user/sampleshuttle/NewSample/CardDetailSample/showMap/Icon/truck.png";
import siteService from "../../../../../services/site.service";
import { getLocationAndVehicleUsage } from "../../../../../actions/locationVehicle";
import Direction from "./Direction";

const MarkerDriver = (props) => {
  const dispatch = useDispatch();
  const [isLocationDriver, setLocationDriver] = useState([]);
  const [siteFrom, setSiteFrom] = useState(null);
  const [siteTo, setSiteTo] = useState(null);
  const [directions, setDirections] = useState(null);
  const locationVehicle = useSelector((state) => state.locationVehicle);
  const { user: currentUser } = useSelector((state) => state.auth);

  const driverIcon = {
    url:
      props.typeBooking === "DeliverySampleShuttleCar"
        ? TruckLocation
        : "data:image/svg+xml;charset=UTF-8," +
          encodeURIComponent(`
          <svg height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg"><path d="m20.772 10.155-1.368-4.104A2.995 2.995 0 0 0 16.559 4H7.441a2.995 2.995 0 0 0-2.845 2.051l-1.368 4.104A2 2 0 0 0 2 12v5c0 .738.404 1.376 1 1.723V21a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-2h12v2a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-2.277A1.99 1.99 0 0 0 22 17v-5a2 2 0 0 0-1.228-1.845zM7.441 6h9.117c.431 0 .813.274.949.684L18.613 10H5.387l1.105-3.316A1 1 0 0 1 7.441 6zM5.5 16a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 5.5 16zm13 0a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 18.5 16z"/></svg>

    `),
    scaledSize: new window.google.maps.Size(25, 20), // Size of the icon
    origin: new window.google.maps.Point(0, 0), // Origin point
    anchor: new window.google.maps.Point(12.5, 20), // Anchor point
  };

  useEffect(() => {
    if (props.inforInCar != null) {
      if (props.siteFrom != null && props.siteTo != null) {
        setSiteFrom(props.siteFrom);
        setSiteTo(props.siteTo);
      }
      if (props.typeBooking === "BetweenSiteCar") {
        const updateLocationDriver = () => {
          siteService
            .getLocationDriverById(currentUser.idUser)
            .then((res) => {
              if (res.data) {
                setLocationDriver([
                  { Lat: res.data[0].lat, Long: res.data[0].lng },
                ]);
                console.log(res.data[0]);
              }
            })
            .catch((error) => {
              setLocationDriver([{ Lat: 0, Long: 0 }]);
            });
        };
        updateLocationDriver();
      } else if (
        props.typeBooking &&
        props.typeBooking === "DeliverySampleShuttleCar"
      ) {
        const updateLocationDriver = () => {
          const fetchData = async () => {
            try {
              await dispatch(getLocationAndVehicleUsage(currentUser.idUser));
            } catch (error) {
              console.error("Failed to fetch:", error);
            }
          };

          fetchData();
        };
        updateLocationDriver();
      } else {
        siteService
          .getLocationDriverById(props.inforInCar.idDriver)
          .then((res) => {
            if (res.data) {
              setLocationDriver([
                { Lat: res.data[0].lat, Long: res.data[0].lng },
              ]);
            }
          })
          .catch((error) => {
            setLocationDriver([{ Lat: 0, Long: 0 }]);
          });
      }
    }
  }, [props.inforInCar, props.refresh]);

  useEffect(() => {
    if (locationVehicle && locationVehicle.result?.length > 0) {
      setLocationDriver([
        {
          Lat: locationVehicle.result[0].lat,
          Long: locationVehicle.result[0].lng,
        },
      ]);
    }
  }, [locationVehicle]);

  useEffect(() => {
    if (siteFrom != null) {
      const directionsService = new window.google.maps.DirectionsService();
      if (props.typeBooking === "DeliverySampleShuttleCar") {
        if (
          props.inforInCar.status === "รอรับสินค้า" &&
          locationVehicle.result?.length > 0 &&
          !locationVehicle.result[0].endTime &&
          isLocationDriver.length > 0
        ) {
          directionsService.route(
            {
              origin: new window.google.maps.LatLng(
                isLocationDriver[0].Lat,
                isLocationDriver[0].Long
              ),
              destination: new window.google.maps.LatLng(
                siteFrom.Lat,
                siteFrom.Long
              ),
              travelMode: window.google.maps.TravelMode.DRIVING,
            },
            (result, status) => {
              if (status === window.google.maps.DirectionsStatus.OK) {
                setDirections(result);
              } else {
                console.error(`error fetching directions ${result}`);
              }
            }
          );
        } else if (
          props.inforInCar.status === "รับสินค้าเรียบร้อย" &&
          locationVehicle.result?.length > 0 &&
          !locationVehicle.result[0].endTime &&
          isLocationDriver.length > 0
        ) {
          directionsService.route(
            {
              origin: new window.google.maps.LatLng(
                isLocationDriver[0].Lat,
                isLocationDriver[0].Long
              ),
              destination: new window.google.maps.LatLng(
                siteTo.Lat,
                siteTo.Long
              ),
              travelMode: window.google.maps.TravelMode.DRIVING,
            },
            (result, status) => {
              if (status === window.google.maps.DirectionsStatus.OK) {
                setDirections(result);
              } else {
                console.error(`error fetching directions ${result}`);
              }
            }
          );
        }
        // Edit here
        else {
          directionsService.route(
            {
              origin: new window.google.maps.LatLng(
                siteFrom.Lat,
                siteFrom.Long
              ),
              destination: new window.google.maps.LatLng(
                siteTo.Lat,
                siteTo.Long
              ),
              travelMode: window.google.maps.TravelMode.DRIVING,
            },
            (result, status) => {
              if (status === window.google.maps.DirectionsStatus.OK) {
                setDirections(result);
              } else {
                console.error(`error fetching directions ${result}`);
              }
            }
          );
        }
      } else if (props.typeBooking === "BetweenSiteCar") {
        if (
          props.inforInCar.isFinish === 0 &&
          (props.inforInCar.targetStatus === "Waiting" ||
            props.inforInCar.targetStatus === "GettingPlace") &&
          isLocationDriver.length > 0
        ) {
          directionsService.route(
            {
              origin: new window.google.maps.LatLng(
                isLocationDriver[0].Lat,
                isLocationDriver[0].Long
              ),
              destination: new window.google.maps.LatLng(
                siteFrom.Lat,
                siteFrom.Long
              ),
              travelMode: window.google.maps.TravelMode.DRIVING,
            },
            (result, status) => {
              if (status === window.google.maps.DirectionsStatus.OK) {
                setDirections(result);
              } else {
                console.error(`error fetching directions ${result}`);
              }
            }
          );
        } else if (
          props.inforInCar.isFinish === 0 &&
          props.inforInCar.targetStatus === "ToPlace" &&
          isLocationDriver.length > 0
        ) {
          directionsService.route(
            {
              origin: new window.google.maps.LatLng(
                isLocationDriver[0].Lat,
                isLocationDriver[0].Long
              ),
              destination: new window.google.maps.LatLng(
                siteTo.Lat,
                siteTo.Long
              ),
              travelMode: window.google.maps.TravelMode.DRIVING,
            },
            (result, status) => {
              if (status === window.google.maps.DirectionsStatus.OK) {
                setDirections(result);
              } else {
                console.error(`error fetching directions ${result}`);
              }
            }
          );
        } else {
          directionsService.route(
            {
              origin: new window.google.maps.LatLng(
                siteFrom.Lat,
                siteFrom.Long
              ),
              destination: new window.google.maps.LatLng(
                siteTo.Lat,
                siteTo.Long
              ),
              travelMode: window.google.maps.TravelMode.DRIVING,
            },
            (result, status) => {
              if (status === window.google.maps.DirectionsStatus.OK) {
                setDirections(result);
              } else {
                console.error(`error fetching directions ${result}`);
              }
            }
          );
        }
      } else {
        directionsService.route(
          {
            origin: new window.google.maps.LatLng(
              props.isLocationDriver[0].Lat,
              props.isLocationDriver[0].Long
            ),
            destination: new window.google.maps.LatLng(
              siteFrom.Lat,
              siteFrom.Long
            ),
            travelMode: window.google.maps.TravelMode.DRIVING,
          },
          (result, status) => {
            if (status === window.google.maps.DirectionsStatus.OK) {
              setDirections(result);
            } else {
              console.error(`error fetching directions ${result}`);
            }
          }
        );
      }
    }
  }, [isLocationDriver, siteFrom, props.inforInCar]);

  useEffect(() => {
    if (props.inforInCar) {
      const directionsService = new window.google.maps.DirectionsService();
      directionsService.route(
        {
          origin: new window.google.maps.LatLng(
            props.isLocationDriver[0].Lat,
            props.isLocationDriver[0].Long
          ), // ใช้พิกัดตำแหน่งเริ่มต้นที่คุณมี
          destination: props.inforInCar.fromPlace, // ใช้ชื่อสถานที่ปลายทาง
          travelMode: window.google.maps.TravelMode.DRIVING,
        },
        (result, status) => {
          if (status === window.google.maps.DirectionsStatus.OK) {
            setDirections(result);
          } else {
            console.error(`error fetching directions ${result}`);
          }
        }
      );
    }
  }, [props.inforInCar]);

  return (
    <>
      {isLocationDriver.length > 0 &&
        ((props.typeBooking === "DeliverySampleShuttleCar" &&
          props.inforInCar.status !== "ส่งสินค้าเรียบร้อย") ||
          (props.typeBooking === "BetweenSiteCar" &&
            props.inforInCar.isFinish === 0)) && (
          <Marker
            position={{
              lat: parseFloat(isLocationDriver[0].Lat),
              lng: parseFloat(isLocationDriver[0].Long),
            }}
            icon={driverIcon}
          />
        )}
      {directions && (
        <Direction
          directions={directions}
          inforInCar={props.inforInCar}
          typeBooking={props.typeBooking}
        />
      )}
    </>
  );
};

export default MarkerDriver;
